import { ApiCallStage } from "./constants";
import { logger } from "./logger";
var notFound = function notFound(name, opt) {
  var _a;
  var response = {
    error: -1,
    errorMessage: "".concat(name, " is not found")
  };
  (_a = opt === null || opt === void 0 ? void 0 : opt.fail) === null || _a === void 0 ? void 0 : _a.call(opt, response);
  logger({
    stage: ApiCallStage.NOT_FOUND,
    type: 'error',
    name: name,
    request: opt,
    state: 'fail',
    response: response
  });
};
export default notFound;